import MainPage from './pages/MainPage';
import ReelPage from './pages/ReelPage';
import FilmPage from './pages/FilmPage';
import { Routes, Route } from "react-router-dom";

import './css/showreel.css';
import './css/site.css';
import './css/home.css';




function App() {


  return (
    <>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/showreelex" element={<ReelPage title="SHOW REEL (EXTENDED)" bread="Extended" youtube="https://www.youtube.com/embed/LsuMlmpp01g?cc_load_policy=0"/>} />    
        <Route path="/actionreel" element={<ReelPage title="ACTION REEL" bread="Action" youtube="https://www.youtube.com/embed/-LjDt3V8Blo?cc_load_policy=0"/>} />    
        <Route path="/martialartsreel" element={<ReelPage title="MARTIAL ARTS REEL" bread="Martial Arts" youtube="https://www.youtube.com/embed/VDZy-Vnh4Qc?cc_load_policy=0"/>} />    
        <Route path="/musicreel" element={<ReelPage title="MUSIC REEL" bread="Music" youtube="https://www.youtube.com/embed/S0PF6x0lEUw?cc_load_policy=0"/>} />    
        <Route path="/showreel" element={<ReelPage title="SHOW REEL" bread="Show" youtube="https://www.youtube.com/embed/2sirGHStOPU?cc_load_policy=0"/>} />    
        <Route path="/shortreel" element={<ReelPage title="SHOW REEL" bread="Show" youtube="https://www.youtube.com/embed/2sirGHStOPU?cc_load_policy=0"/>} />    
        <Route path="/longreel" element={<ReelPage title="SHOW REEL (EXTENDED)" bread="Show" youtube="https://www.youtube.com/embed/LsuMlmpp01g?cc_load_policy=0"/>} />    
        
        {/*films*/}
        <Route path="/detour" element={<FilmPage title="THE DETOUR" bread="The Detour" youtube="https://www.youtube.com/embed/pAfQ24JINS4?cc_load_policy=0"/>} />  
        <Route path="/lday"  element={<FilmPage title="LABOUR DAY" bread="Labour Day" youtube="https://www.youtube.com/embed/FGN-69nyYzg?cc_load_policy=0"/>} />    
        <Route path="/shattered" element={<FilmPage title="SHATTERED HEARTS" bread="Shattered Hearts" youtube="https://player.vimeo.com/video/932844032?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"/>} />    
        <Route path="/gift"  element={<FilmPage title="THE GIFT" bread="The Gift" youtube="https://www.youtube.com/embed/Ij1TvNsWABA?cc_load_policy=0"/>} />    
        <Route path="/loop"  element={<FilmPage title="LOOP" bread="Loop" youtube="https://www.youtube.com/embed/SKeGVlBAiwI?cc_load_policy=0"/>} />    
        <Route path="/bt"    element={<FilmPage title="BLACK THURSDAY" bread="Black Thursday" youtube="https://www.youtube.com/embed/TYtS8G0xDxY?cc_load_policy=0&amp;start=575"/>} />    
        <Route path="/veil"  element={<FilmPage title="VEIL" bread="Veil" youtube="https://www.youtube.com/embed/3RfqlibVebA?cc_load_policy=0&amp;start=589"/>} />    
        <Route path="/veil2" element={<FilmPage title="VEIL 2" bread="Veil 2" youtube="https://www.youtube.com/embed/3RfqlibVebA?cc_load_policy=0&amp;start=948"/>} />    
        <Route path="/128"   element={<FilmPage title="128 CIRCLE" bread="128 Circle" youtube="https://www.youtube.com/embed/6ja-w5aRxe4?cc_load_policy=0&amp;start=847"/>} />    
        <Route path="/waste" element={<FilmPage title="WASTERLANDERS" bread="Wastelanders" youtube="https://www.youtube.com/embed/Th5s-G-vK3I?cc_load_policy=0"/>} />    
        <Route path="/knock" element={<FilmPage title="KNOCK, KNOCK" bread="Knock, Knock" youtube="https://www.youtube.com/embed/l6jYjw41D1Y?cc_load_policy=0"/>} />    

        {/*other film links*/}
        <Route path="/waltz" element={<FilmPage title="WHITE CROSS WALTZ" bread="White Cross Waltz" youtube="https://www.youtube.com/embed/3YtNr_QbRBA?cc_load_policy=0"/>} />    
        <Route path="/dline" element={<FilmPage title="DEADLINE" bread="Deadline" youtube="https://www.youtube.com/embed/H6jTn2B-4Gk?cc_load_policy=0"/>} />    
        <Route path="/fe"    element={<FilmPage title="FATHER'S EMBRACE" bread="Father's Embrace" youtube="https://www.youtube.com/embed/QczF7LSq8Mo?cc_load_policy=0"/>} />    

        {/*ads*/}
        <Route path="/csa"  element={<FilmPage title="CSA (Unseen Enemy)" bread="CSA (Unseen Enemy)" youtube="https://www.youtube.com/embed/mI1s8W6Q0gg?cc_load_policy=0"/>} />    
        <Route path="/citi" element={<FilmPage title="Citibank" bread="Citibank" youtube="https://www.youtube.com/embed/HwWXILSq4q8?cc_load_policy=0"/>} />    
        <Route path="/wf"   element={<FilmPage title="Workforce Singapore" bread="Workforce Singapore" youtube="https://www.youtube.com/embed/rotypjzdP4Y?cc_load_policy=0"/>} />    
        <Route path="/sp"   element={<FilmPage title="SP Group" bread="SP Group" youtube="https://www.youtube.com/embed/yooM9mn-yqU?cc_load_policy=0k"/>} />    
        <Route path="/mc"   element={<FilmPage title="McDonald's" bread="McDonald's" youtube="https://www.youtube.com/embed/PsuDkjfKPf8?cc_load_policy=0"/>} /> 

        {/*other*/}

        {/*Comp Card*/}
        {/*The div ensures the iframe fits nicely in browser*/}
        <Route path="/comp"  element={
          <div style={{ width: "100vw", height: "100vh", overflow: "hidden" }}>
            <iframe
              src="/pdf/JinLu-CompCard2026.pdf"
              style={{ width: "100%", height: "100%", border: "none" }}
              title="PDF Viewer"
            />
          </div>
        } />    
   
      </Routes>
    </>
  );
}

export default App;
